module.exports = __webpack_public_path__ + "img/npc-face.0c353b82.png";